var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas",style:({
        ..._vm.getCanvasStyle(_vm.canvasStyle),
        width: _vm.changeStyleWithScale(_vm.canvasStyle.width) + 'px',
        height: _vm.changeStyleWithScale(_vm.canvasStyle.height) + 'px',
    })},_vm._l((_vm.canvasData),function(item,index){return _c('ComponentWrapper',{key:index,attrs:{"config":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }